import { render, staticRenderFns } from "./audiolist.vue?vue&type=template&id=6c60d722&scoped=true"
import script from "./audiolist.vue?vue&type=script&lang=js"
export * from "./audiolist.vue?vue&type=script&lang=js"
import style0 from "./audiolist.vue?vue&type=style&index=0&id=6c60d722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60d722",
  null
  
)

export default component.exports